<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12" sm="12">
        <entries
          :entries="entries.filter(e => e.status === 'accepted' || e.status === 'rejected' || e.status === 'manual')"
          title="Historique"
          type="history"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import Entries from "@/components/Entries";

export default {
  name: "Pending",
  components: { Entries },
  data: () => ({
    entries: []
  }),
  async mounted() {
    try {
      const { data: entries } = await axios({
        method: "get",
        url: process.env.VUE_APP_API_URI
      });
      this.entries = entries;
    } catch (e) {
      console.log(e);
    }
  }
};
</script>
